import React, { Component } from 'react';

class Services extends Component {
   render() {

      if (this.props.data) {
         var services = this.props.data.services.map(function (service) {
            return <section id={service.name.split(" ").join("")}><li key={service.name.split(" ").join("")} >
               <blockquote>
                  <div className={service.position}>
                  <h3>{service.name}</h3>
                  <img src="./dogdayslogo_transparent.png" alt={service.name}/>
                  </div>
                  <p>{service.introduction}</p> < br/>
                  <p>{service.description}</p> < br/>
                  <p>{service.calltoaction}</p>  < br/>                 
               
               </blockquote>
            </li>
            </section>
         })
      }

      return (
         <section id="services">
            <div className="text-container">
               <div className="row">

                  <div className="twelve columns header-col">
                     <h1><span>Available Services</span></h1>
                  </div>
               </div>
               <div className="row">
                  <div className="twelve columns flex-container">
                     <div className="services-container">
                        <ul className="services">
                           {services}
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      );
   }
}

export default Services;
